import { Observable } from 'rxjs';
import _ from 'lodash';
import { AnyAction, Store } from 'redux';
import { ActionsObservable } from 'redux-observable';
import * as Sentry from '@sentry/react';

import BudgetsApi from 'entities/budget/api';
import DonationCreditRulesApi from 'entities/donationCreditRule/api';
import { selectUser } from 'entities/user/selectors';
import { STORE as STORE_USER } from 'entities/user/constants';
import { Features } from 'utils/features';
import history from 'utils/history';

import { INIT } from './constants';
import { initFailedAction, initSuccessAction } from './actions';

const init = (action$: ActionsObservable<AnyAction>, store: Store): Observable<AnyAction> =>
  action$.ofType(INIT, STORE_USER).mergeMap(() => {
    const state = store.getState();
    const user = selectUser(state);

    if (!user) {
      return [];
    }

    if (!user?.hasFeature(Features.DONATION_CREDIT)) {
      history.replace('/donations/donors');
      Sentry.captureMessage("User reached DonationsSeedPage without 'donationCredit' permission", {
        level: 'info',
      });
      return [];
    }

    const actions: Observable<AnyAction>[] = [
      BudgetsApi.fetchAll(),
      DonationCreditRulesApi.fetchAll(),
    ];

    return Observable.combineLatest(actions)
      .mergeMap((resultingActions) => [..._.flatten(resultingActions), initSuccessAction()])
      .catch((e) => Observable.of(initFailedAction(e)));
  });

export default [init];
